export default "__VITE_ASSET__EFLyLxMN__"